import { useContext } from "react";
import { notification } from "antd";
import { deleteRequest, getRequest, handleResponse, patchFormRequests, patchRequests, postFormRequests, putFormRequest } from "../../context/requestTypes";
import { AxiosContext } from "../../context/AxiosContext";
import { useMutation, useQuery } from "react-query";
import { useRecoilValue } from "recoil";
import authAtom from "../../atoms/auth/auth.atom";



export function useGetAdss(params, key) { // /api/v1/AdService/GetAds
  const url = "/Ad/GetAds";
  const axios = useContext(AxiosContext);
  return useQuery(["key:get_all_ads", ...(key||[])?.map(d => params?.[d])], () => getRequest(axios, url, params), {
    onSuccess: (response) => handleResponse(response),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useGetAds(successAction) {
  const url = "/Ad/GetAd/";
  const axios = useContext(AxiosContext);
  return useMutation((id) => getRequest(axios, url+id), {
    onSuccess: (response) => handleResponse(response, () => successAction?.()),
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePostAds(successAction) {  ///api/v1/Ad/CreateAd
  const url = "/Ad/CreateAd";
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => postFormRequests(url, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePutAds(successAction) { // /api/v1/Ad/ChangeAdStatus/{adId}
  const url = "/Ad/ChangeAdStatus/";
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => putFormRequest(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function useAdsApproval(successAction) { // /api/v1/AdService/ApproveAd/{adId}
  const url = "/Ad/ApproveAd/";
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => putFormRequest(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}


export function useDeleteAds(successAction) { // /api/v1/Ad/RemoveAd/{adId}
  const url = `/Ad/RemoveAd/`; 
  const axios = useContext(AxiosContext);
  return useMutation((id) => deleteRequest(axios, url+id), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}

export function usePatchAds(successAction) {
  const url = "/Ad/EditAds/"; 
  const { user } = useRecoilValue(authAtom)
  return useMutation((payload) => patchFormRequests(url+payload?.id, payload, user?.token), {
    onSuccess: (response) => {
      handleResponse(response, () => {
        successAction?.()
        notification.success({
          message: "Success!",
          description: response?.message || "action successful",
        })
      })
    },
    onError: (error) => notification.error({
      message: "Error!",
      description: error?.message ? (Object.entries(error?.errors || {key:[error?.message]})?.map(([,value]) => value?.join(", ")))?.join(", ") : "something went wrong please check internet connection.",
    }),
  });
}